<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item :label="$t('apply.no')" prop="applyNo">
                    <el-input class="handle-input" v-model="queryCondition.applyNo" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('apply.applyType')" prop="applyType">
                    <el-select class="handle-input" v-model="queryCondition.applyType" clearable style="width:100%">
                      <el-option :label="$t('common.all')" value=""></el-option>
                      <el-option :key="index" v-for="(item,index) in applyTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('apply.subject')" prop="subject">
                    <el-input class="handle-input" v-model="queryCondition.subject" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('apply.sourcing')" prop="sourcingNo">
                    <el-input class="handle-input" v-model="queryCondition.sourcingNo" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item :label="$t('apply.shortlistedSuppliers')" prop="supplierCode">
                      <el-input clearable class="handle-input" suffix-icon="el-icon-search" @click.native='showSelSupplierDialog=true;SupplierNameDialogReset = true' v-model="queryCondition.supplierCode" @clear="clearSupplierName" style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item :label="$t('apply.quotationType')" prop="quotationType">
                      <el-select class="handle-input" v-model="queryCondition.quotationType" clearable style="width:100%">
                        <el-option :label="$t('common.all')" value=""></el-option>
                        <el-option :key="index" v-for="(item,index) in quotationTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item :label="$t('apply.quotationStatus')" prop="quotationStatus">
                      <el-select class="handle-input" v-model="queryCondition.quotationStatus" clearable style="width:100%">
                        <el-option :label="$t('common.all')" value=""></el-option>
                        <el-option :key="index" v-for="(item,index) in quotationStatusList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item :label="$t('apply.sourcingStatus')" prop="sourcingStatus">
                      <ic-select clearable class="handle-input" v-model="queryCondition.sourcingStatus" table="TT_SOURCING_HEAD" field="STATUS" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item :label="$t('apply.status')" prop="status">
                      <el-select class="handle-input" v-model="queryCondition.status" clearable style="width:100%">
                        <el-option :label="$t('common.all')" value="all"></el-option>
                        <el-option :key="index" v-for="(item,index) in statusList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item :label="$t('common.createBy')" prop="buyerName">
                      <el-input clearable class="handle-input" v-model="queryCondition.buyerName" style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="创建日期(从)" prop="createDate">
                      <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.createDate" type="date" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="创建日期(至)" prop="createEndDate">
                      <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.createEndDate" type="date" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
            <el-button size="mini" @click="restQueryFormThis" type="primary">{{$t('common.reset')}}</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" v-acl="ApplyCreateNew" @click="addNewApply(-99999)">{{$t('common.addNew')}}</el-button>
        <el-button size="mini" class="btn" type="danger" v-acl="lineApplyDelete" @click="deleteQuotationApply">{{$t('common.del')}}</el-button>
        <el-button size="mini" class="btn" type="primary" v-acl="lineApplyClose" @click="closeQuotationApply">{{$t('common.cancellation')}}</el-button>
      </el-row>
      <el-table sortable max-height="1750px" :data="applyList" ref="applyDataTable" border highlight-current-row class="table">
        <el-table-column align="center" width="50" :label="$t('common.select')">
          <template slot-scope="scope">
            <el-radio :disabled="scope.row.status=='3'" v-model="radioVal" @change.native="getSelectRow(scope.row)" :label="scope.row.ttQuotationApplyId">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <!--单据编号-->
        <el-table-column show-overflow-tooltip align="center" sortable prop="applyNo" :label="$t('apply.no')" min-width="100px">
          <template slot-scope="scope">
            <el-link type="primary" @click="openQuotationApplyDetail(scope.row)"> {{scope.row.applyNo}} </el-link>
          </template>
        </el-table-column>
        <!--类型-->
        <el-table-column show-overflow-tooltip align="center" sortable prop="applyTypeI18n" :label="$t('apply.applyType')" min-width="70px"></el-table-column>
        <!--主题-->
        <el-table-column show-overflow-tooltip align="center" sortable prop="subject" :label="$t('apply.subject')" min-width="150px"></el-table-column>
        <!--入围供应商-->
        <el-table-column show-overflow-tooltip align="center" sortable prop="supplierNames" :label="$t('apply.shortlistedSuppliers')" min-width="100px"></el-table-column>
        <!--报价类型-->
        <el-table-column show-overflow-tooltip align="center" sortable prop="quotationTypeI18n" :label="$t('apply.quotationType')" min-width="90px"></el-table-column>
        <!--创建人-->
        <el-table-column show-overflow-tooltip align="center" sortable prop="name" :label="$t('common.createBy')" min-width="90px"></el-table-column>
        <!--创建日期-->
        <el-table-column show-overflow-tooltip align="center" sortable prop="createDate" :label="$t('common.createDate')" min-width="90px"></el-table-column>
        <!--申请单状态-->
        <el-table-column show-overflow-tooltip align="center" sortable prop="statusI18n" :label="$t('apply.status')" min-width="100px"></el-table-column>
        <!--报价轮次-->
        <el-table-column show-overflow-tooltip align="center" sortable prop="roundNumber" :label="$t('apply.quotationRound')" min-width="100px"></el-table-column>
        <!--报价状态-->
        <el-table-column show-overflow-tooltip align="center" sortable prop="quotationStatusI18n" :label="$t('apply.quotationStatus')" min-width="100px"></el-table-column>
        <!--报价确认申请单-->
        <el-table-column show-overflow-tooltip align="center" sortable prop="sourcingNo" :label="$t('apply.sourcing')" min-width="130px">
          <template slot-scope="scope">
            <el-link @click.native="openSoucingInfo(item.sourcingNo)" style="display: block" type="primary" v-for="(item,index) in scope.row.sourcingList" :key="index">{{item.sourcingNo}}</el-link>
          </template>
        </el-table-column>
        <!--报价确认状态-->
        <el-table-column show-overflow-tooltip align="center" sortable :label="$t('apply.sourcingStatus')" min-width="110px" prop="status">
          <template slot-scope="scope">
            <el-link style="display: block" type="info" v-for="(item,index) in scope.row.sourcingList" :key="index">{{item.status}}</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <!--===分页组件===-->
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
    <!--=========数据列表END================-->

    <el-dialog :visible.sync="showSelSupplierDialog" append-to-body width="80%">
      <SelSupplier :multipleSelectionFlag="false" v-if="SupplierNameDialogReset" ref="supplierSelRef" @subCallMethod="selectSupplierMethod"></SelSupplier>
    </el-dialog>
  </div>
</template>
<script>
import { applyService } from "../../../api/quotation-apply/quotation-apply";
import { inputChoiceService } from "../../../api/common/input-choice";
import commonFunction from "../../../utils/dataTableUtils"
import SelSupplier from '../base-data/carrier-sel-page'

import { Message } from "element-ui";
import IcSelect from "@/components/common/icSelect";
import store from '@/store/index'
import paginationMixin from '../../../mixins/pagitionMixin';
import { log } from 'util';
export default {
  name: 'apply',
  mixins: [paginationMixin],
  components: {
    IcSelect,
    SelSupplier
  },
  data() {
    return {
      totalCount: 0,
      applyList: [],
      labelPosition: 'right',
      SupplierNameDialogReset: false,
      isShow: false,//控制查询列表收缩展开
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        applyNo: null,
        applyType: null,
        subject: null,
        sourcingNo: null,
        supplierCode: null,
        quotationType: null,
        quotationStatus: null,
        sourcingStatus: null,
        status: null,
        buyerName: null,
        createDate: null,
        createEndDate: null,
        tmSupplierId: null
      },
      statusList: [],
      quotationStatusList: [],
      sourcingStatusList: [],
      quotationTypeList: [],
      applyTypeList: [],
      radioVal: null,
      selectRow: null,
      showSelSupplierDialog: false,
    }
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  beforeRouteEnter(to, from, next) {
    console.log('to',to);
    applyService.getQuotationApplyData(to.meta.reqData).then((res) => {
      next(vm => {
        vm.queryCondition = to.meta.reqData;
        vm.applyList = res.resultData;
        vm.totalCount = res.totalCount;
      })
    })
  },
  created() {
    this.queryData(1);
    this.getInputChoiceValues();
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      applyService.getQuotationApplyData(this.queryCondition).then((res) => {
        this.applyList = res.resultData;
        this.totalCount = res.totalCount;
      });
    },
    addNewApply: function (applyId) {
      this.$router.replace({ name: 'applyDetail', params: { applyId: applyId, source: 'apply' } });
    },
    openQuotationApplyDetail: function (row) {
      if (this.actionCheck.actionCheck('ApplyInfo') === false) {
        this.$message.error(this.$t('common.noPermission'))
        return false

      }
      this.$router.push({ name: 'applyDetail', params: { applyId: row.ttQuotationApplyId, source: 'apply', applyType: row.applyType } });
    },
    //清除校验信息
    clearVlidate: function (refFormName) {
      if (this.$refs[refFormName]) {
        this.$refs[refFormName].clearValidate();
      }
    },
    //单选操作
    getSelectRow: function (row) {
      this.selectRow = [];
      this.selectRow = row;
    },
    deleteQuotationApply: function () {
      if (this.selectRow == null) {
        //请选择需要删除的申请单
        Message({ message: this.$t('apply.selectDelApply'), type: "warning" });
      } else {
        let delId = this.selectRow.ttQuotationApplyId;
        let ownerFlag = this.selectRow.ownerFlag;
        let source = this.selectRow.source;
        //只能删除自己的单据，供应商创建的也不可以删除
        if (!ownerFlag || (ownerFlag && source == 'SUP')) {
          Message({ message: "只能操作自己名下的单据", type: "warning" });
          return;
        }
        //判断单据是否为草稿状态
        if (this.selectRow.status != '1') {
          //只有草稿状态的申请单才可以删除
          Message({ message: this.$t('apply.delApplyParam'), type: "warning" });
          return;
        }
        //请确认是否删除!
        this.$confirm(this.$t('common.delConfirm'), this.$t('common.tips'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          cancelButtonClass: 'el-button--primary',
          confirmButtonClass: 'el-button--primary',
          type: 'warning'
        }).then(() => {
          applyService.delSelQuotationApply(delId).then((res) => {
            if (res.meta.success) {
              this.selectRow = null;
              this.radioVal = null;
              Message({ message: this.$t('common.delSuccess'), type: "success" });
              this.queryData();
            } else {
              Message({ message: this.$t('common.delError'), type: "error" });
            }
          });
        }).catch(() => {

        });
      }
    },
    closeQuotationApply: function () {
      console.log('selectRow', this.selectRow);
      if (this.selectRow == null) {
        //请选择需要关闭的申请单!
        Message({ message: this.$t('apply.selectCloseApply'), type: "warning" });
      } else {
        let delId = this.selectRow.ttQuotationApplyId;
        let ownerFlag = this.selectRow.ownerFlag;

        if (!ownerFlag) {
          Message({ message: "只能操作自己名下的单据", type: "warning" });
          return;
        }
        //请确认是否关闭
        this.$confirm(this.$t('common.closeConfirm'), this.$t('common.tips'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          cancelButtonClass: 'el-button--primary',
          confirmButtonClass: 'el-button--primary',
          type: 'warning'
        }).then(() => {
          applyService.closeApplyInfo(delId).then((res) => {
            if (res.meta.success) {
              this.selectRow = null;
              this.radioVal = null;
              Message({ message: this.$t('common.updateSuccess'), type: "success" });
              this.queryData();
            } else {
              Message({ message: this.$t('common.updateError'), type: "error" });
            }
          });
        }).catch(() => {

        });
      }
    },
    selectSupplierMethod: function (supList) {
      this.queryCondition.supplierCode = supList[0].supplierName;
      this.queryCondition.tmSupplierId = supList[0].tmSupplierId;
      this.showSelSupplierDialog = false;
    },
    //查询条件重置方法
    restQueryFormThis: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        applyNo: null,
        applyType: null,
        subject: null,
        sourcingNo: null,
        supplierCode: null,
        quotationType: null,
        quotationStatus: null,
        sourcingStatus: null,
        status: null,
        buyerName: null,
        createDate: null,
        createEndDate: null,
        tmSupplierId: null
      }
      this.radioVal = ''
      this.selectRow = null
      this.queryData();
    },
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["TT_QUOTATION_APPLY:STATUS"] = "TT_QUOTATION_APPLY:STATUS";
      mapObj["TT_QUOTATION:STATUS"] = "TT_QUOTATION:STATUS";
      mapObj["TT_SOURCING:STATUS"] = "TT_SOURCING:STATUS";
      mapObj["TT_QUOTATION_APPLY:QUOTATION_TYPE"] = "TT_QUOTATION_APPLY:QUOTATION_TYPE";
      mapObj["TT_QUOTATION_APPLY:APPLY_TYPE"] = "TT_QUOTATION_APPLY:APPLY_TYPE";
      inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
        this.statusList = res["TT_QUOTATION_APPLY:STATUS"];
        this.quotationStatusList = res["TT_QUOTATION:STATUS"];
        this.sourcingStatusList = res["TT_SOURCING:STATUS"];
        this.quotationTypeList = res["TT_QUOTATION_APPLY:QUOTATION_TYPE"];
        this.applyTypeList = res["TT_QUOTATION_APPLY:APPLY_TYPE"];
      });
    },
    openSoucingInfo: function (sourcingNo) {
      this.$router.push({
        path: "/sourcing-Detail",
        query: { sourcingNo: sourcingNo }
      });
    },
    clearSupplierName() {
      this.SupplierNameDialogReset = false
      this.queryCondition.tmSupplierId = null
      this.$nextTick(() => {
        this.SupplierNameDialogReset = true
      })
    }
  },
  extends: commonFunction
}
</script>
<style scoped >
.handle-input {
  width: 90%;
}
.form_border {
  border: 1px solid #eaeefb;
  padding: 10px 10px 0;
}
</style>
